export enum additionalMargins {
    default = 1.8,
    desktop= 5,
    stickyFooter = 2,
    playBingoButton = 4.6,
    bottomMenu = 3,
    stickyBtnFromSlotPageAddedOnPage = 4
}

export const HEADER_AND_FOOTER_HEIGHT = 110;
